import { render } from "./MyTeamsView.vue?vue&type=template&id=b7109308"
import script from "./MyTeamsView.vue?vue&type=script&lang=js"
export * from "./MyTeamsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__